import { didCancel, task, timeout } from 'ember-concurrency';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import MessagingRoutesBaseHandler from './base-handler.js';

export default class MessagingRoutesContactsHandler extends MessagingRoutesBaseHandler {
  @service alertManager;
  @service intl;
  @service messaging;

  @tracked search = '';
  @tracked isRecentContacts = true;

  onVisit = task({ drop: true }, async () => {
    await this.searchContacts.perform();
  });

  searchContacts = task({ restartable: true }, async () => {
    const filter = this.search.trim() ? { search: this.search.trim() } : undefined;

    // Add debounce only for search input (not initial load)
    if (this.search) {
      await timeout(300);
    }

    try {
      await this.messaging.getContacts.perform(filter);
      this.isRecentContacts = !this.search;
    } catch (err) {
      this.handleError(err);
    }
  });

  updateSearch(search) {
    this.search = search;
    this.searchContacts.perform();
  }

  async loadMoreContacts(model) {
    try {
      await this.messaging.loadMoreContacts.perform(model);
    } catch (err) {
      this.handleError(err);
    }
  }

  handleError(err) {
    if (didCancel(err)) return;
    this.alertManager.broadcast('toast', {
      message: this.intl.t('emc.general_error'),
      type: 'error',
    });
  }
}
